var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_c('strong',[_vm._v("Calumis Akademie")])]),_c('v-spacer')],1),_c('v-divider'),_c('v-card-text',[_c('v-main',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v("Willkommen zur Calumis Akademie")])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }